import theme from '@styles/theme';
const textAlignVariantContent = {
  start: 'left',
  center: 'center',
  end: 'right'
};
const maxWidthContentWidth = {
  small: ['100%', '100%', '100%', '50%', 438, 599],
  medium: 723,
  large: 908
};
const getHeight = (variant: 'default' | 'other') => {
  if (variant === 'other') {
    return ['160vw', '130vw', '72.397vw', '50.973vw', '50.973vw', '37.396vw'];
  }
  return ['auto', 'auto', '60vw', '50vw', '50vw', '46.875vw'];
};
export default {
  fullImageWithHeading: (variant: 'default' | 'other', variantContent: 'start' | 'center' | 'end', variantAlignContent: 'start' | 'center' | 'end') => ({
    position: 'relative',
    bg: theme.rawColors.neutralWhite,
    zIndex: theme.zIndex.documentUp,
    height: getHeight(variant),
    display: 'flex',
    justifyContent: variantContent,
    alignItems: variantAlignContent,
    p: 0,
    ...(variant === 'default' && {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      '& img': {
        height: ['139vw', '139vw', 'inherit', 'inherit', 'inherit', 'auto']
      }
    }),
    ...(variant === 'other' && {
      '& img': {
        objectPosition: 'top'
      }
    })
  }),
  fullImageVideoContent: {
    width: '100%',
    height: '177.335vw',
    display: ['inherit', 'inherit', 'flex', 'flex', 'flex'],
    alignItems: ['inherit', 'inherit', 'center', 'center', 'center'],
    alignContent: ['inherit', 'inherit', 'center', 'center', 'center'],
    flexDirection: ['inherit', 'inherit', 'column', 'column', 'column'],
    justifyContent: ['inherit', 'inherit', 'center', 'center', 'center'],
    '& button': {
      position: 'absolute',
      bottom: ['64px', '64px', 'auto', 'auto', 'auto'],
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: theme.zIndex.documentUp,
      marginTop: ['auto', 'auto', '154px', '214px', '320px', '200px']
    }
  },
  fullImageContent: (variant: 'default' | 'other', variantContent: 'start' | 'center' | 'end', contentWidth: 'small' | 'medium' | 'large') => ({
    ...(variant === 'other' && {
      left: ['0', '0', '0', '155px', '195px'],
      color: theme.rawColors.neutralWhite,
      p: '0px 24px',
      position: ['absolute', 'absolute', 'absolute', 'absolute', 'absolute']
    }),
    ...(variant === 'default' && {
      position: ['relative', 'relative', 'absolute', 'absolute', 'absolute'],
      backgroundColor: [theme.rawColors.beige300, theme.rawColors.beige300, 'transparent', 'transparent', 'transparent'],
      color: [theme.rawColors.darkGrey700, theme.rawColors.darkGrey700, theme.rawColors.neutralWhite, theme.rawColors.neutralWhite, theme.rawColors.neutralWhite],
      p: ['64px 40px 40px 40px', '64px 40px 40px 40px', '0 40px', '0 40px', '0 40px'],
      '& button': {
        bottom: ['-120vw', '-120vw', 'inherit', 'inherit', 'inherit'],
        position: ['absolute', 'absolute', 'relative', 'relative', 'relative'],
        left: ['50%', '50%', 'inherit', 'inherit', 'inherit'],
        transform: ['translateX(-50%)', 'translateX(-50%)', 'inherit', 'inherit', 'inherit']
      },
      '& p': {
        p: ['0px', '0px', '0px 0px 24px 0px', '0px 0px 24px 0px', '0px 0px 24px 0px']
      }
    }),
    maxWidth: maxWidthContentWidth[contentWidth],
    width: '100%',
    zIndex: theme.zIndex.documentUp,
    textAlign: textAlignVariantContent[variantContent],
    'h4.headings.heading__four': {
      pb: [16, 16, 16, 24],
      span: {
        fontSize: variant === 'other' ? theme.fontSizes.text : theme.fontSizes.h3,
        lineHeight: variant === 'other' ? '170%' : null,
        letterSpacing: variant === 'other' ? theme.letterSpacings.smallCaps : theme.letterSpacings.normal
      }
    },
    '& h1,& h2': {
      color: [theme.rawColors.neutralBlack, theme.rawColors.neutralBlack, theme.rawColors.neutralWhite, theme.rawColors.neutralWhite, theme.rawColors.neutralWhite]
    }
  }),
  textDescription: {
    pb: [16, 16, 16, 24],
    span: {
      fontSize: theme.fontSizes.text,
      lineHeight: '175%',
      letterSpacing: theme.letterSpacings.smallCaps
    }
  }
};